/* unplugin-vue-components disabled */import { render } from "./tenant-skills.vue?vue&type=template&id=ac4b54ba&scoped=true"
import script from "./tenant-skills.vue?vue&type=script&lang=js"
export * from "./tenant-skills.vue?vue&type=script&lang=js"

import "./tenant-skills.vue?vue&type=style&index=0&id=ac4b54ba&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac4b54ba"],['__file',"src/pages/tenants/settings/tenant-skills.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac4b54ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac4b54ba', __exports__)) {
    api.reload('ac4b54ba', __exports__)
  }
  
  module.hot.accept("./tenant-skills.vue?vue&type=template&id=ac4b54ba&scoped=true", () => {
    api.rerender('ac4b54ba', render)
  })

}


export default __exports__